import { Section } from '@/components/layout';
import { Reveal } from '@/components/motion';
import { ResponsiveImage } from '@/components/media';
import { DividerCorazon, EstelasCamara } from '../icons/BogotaIcons';
import styles from './CamaraCuanticaBogota.module.css';

/* =============================================================================
 * S3 · CÁMARA CUÁNTICA  (mockup y 791–1047 · 51,5–68,2 % del alto)
 * -----------------------------------------------------------------------------
 * Dos columnas asimétricas: texto a la izquierda (≈48 %) e imagen a la derecha
 * (≈52 %) SANGRANDO por el borde derecho. Fondo crema con un resplandor cálido
 * detrás de la imagen y estelas doradas que salen del texto hacia ella.
 *
 * La Cámara de Bogotá es el CUBO / RECINTO octogonal de vidrio con estructura
 * dorada resplandeciente (guía §8). No es la sala blanca de Miami: cada destino
 * conserva su composición propia (ADR-005 §1).
 *
 * `Origen` va en dorado — última palabra resaltada, como el mockup.
 * ========================================================================== */
export function CamaraCuanticaBogota() {
  return (
    <Section
      background="none"
      spacing="flush"
      width="full"
      labelledBy="bogota-camara-titulo"
      className={styles.section}
    >
      {/* LAS ESTELAS DEL PÓSTER, que faltaban. Van FUERA de `.layout` y en su
          propia capa absoluta porque cruzan la banda entera de arriba abajo:
          dentro de una celda del grid habrían quedado recortadas por la fila.
          Sólo de 1024 arriba — por debajo el layout se apila y no hay hueco
          entre el texto y la escena donde barrer. */}
      <span className={styles.estelas} aria-hidden="true">
        <EstelasCamara />
      </span>

      <div className={styles.layout}>
        <Reveal className={styles.textCol}>
          <div className={styles.text}>
            <p className={styles.eyebrow}>El momento más profundo</p>

            <h2 id="bogota-camara-titulo" className={styles.title}>
              Cámara Cuántica
            </h2>

            <DividerCorazon className={styles.divider} />

            <p className={styles.body}>
              Una experiencia inmersiva y sagrada que armoniza tu campo energético, libera memorias y
              te reconecta con tu Esencia <span className={styles.accent}>Origen</span>.
            </p>
          </div>
        </Reveal>

        <div className={styles.mediaCol}>
          <span className={styles.glow} aria-hidden="true" />
          <ResponsiveImage
            asset="bogota/camara"
            className={styles.media}
            sizes="(min-width: 64rem) 52vw, 100vw"
          />
        </div>
      </div>
    </Section>
  );
}
